"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var exceptions_1 = require("../exceptions");

var socket_1 = __importDefault(require("../socket"));

var utils_1 = require("../utils");

var types_1 = require("./types");

exports.ClientEventType = types_1.EventType;

var Client =
/** @class */
function () {
  function Client(host, port) {
    if (port === void 0) {
      port = 5015;
    }

    this.host = host;
    this.port = port;
    this.socket = new socket_1.default();
    this.closed = false;
  }

  Client.prototype.connect = function (onConnect, timeout) {
    if (timeout === void 0) {
      timeout = 5000;
    }

    return __awaiter(this, void 0, void 0, function () {
      var error_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , utils_1.resolveInMS(function () {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      if (!!this.socket.socketId) return [3
                      /*break*/
                      , 2];
                      return [4
                      /*yield*/
                      , this.socket.create()];

                    case 1:
                      _a.sent();

                      _a.label = 2;

                    case 2:
                      return [4
                      /*yield*/
                      , this.socket.connect(this.port, this.host, onConnect)];

                    case 3:
                      _a.sent();

                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }, timeout)];

          case 1:
            _a.sent();

            return [3
            /*break*/
            , 3];

          case 2:
            error_1 = _a.sent();
            this.throw(error_1);
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Client.prototype.write = function (data) {
    if (this.closed) throw new TypeError('Cannot write to closed client.');
    return this.socket.write(data);
  };

  Client.prototype.close = function () {
    if (this.closed) return;
    this.socket.destroy();
    this.closed = true;
  };

  Client.prototype.on = function (eventName, callback) {
    this.socket.on(eventName, callback);
  };

  Client.prototype.off = function (eventName, callback) {
    this.socket.off(eventName, callback);
  };

  Client.prototype.throw = function (err) {
    throw new exceptions_1.ClientError(err);
  };

  return Client;
}();

exports.default = Client;